/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPublicLoginConfigurationOpenIdFromJSON, StreemApiPublicLoginConfigurationOpenIdToJSON, } from './';
export function StreemApiPublicLoginConfigurationFromJSON(json) {
    return StreemApiPublicLoginConfigurationFromJSONTyped(json, false);
}
export function StreemApiPublicLoginConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'openId': !exists(json, 'open_id') ? undefined : StreemApiPublicLoginConfigurationOpenIdFromJSON(json['open_id']),
        'logoutEndpoint': !exists(json, 'logout_endpoint') ? undefined : json['logout_endpoint'],
    };
}
export function StreemApiPublicLoginConfigurationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'open_id': StreemApiPublicLoginConfigurationOpenIdToJSON(value.openId),
        'logout_endpoint': value.logoutEndpoint,
    };
}
//# sourceMappingURL=StreemApiPublicLoginConfiguration.js.map